<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Automações habilitadas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogCadAutomacao" width="500">
            <template v-slot:activator="{ on }">
              <v-btn icon dark color="info" v-on="on">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <cad-automacao @fechar="dialogCadAutomacao = false" @info="showInfo" @error="showError"></cad-automacao>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-list>
          <template v-for="(automacao, index) in automacoes">
            <v-menu
              :key="automacao.id"
              offset-y
              bottom
              transition="slide-y-transition"
              :max-width="300"
            >
              <template v-slot:activator="{ on }">
                <v-list-tile avatar v-on="on">
                  <v-list-tile-avatar>
                    <v-icon color="success" size="30">android</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-text="`Automação ${automacao.nome}`"
                      class="title font-weight-light grey--text text--darken-2"
                    ></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon v-on="on" @click="selecionarAutomacao(automacao)">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
              <v-card>
                <v-card-title
                  class="subheading font-weight-regular pb-0 grey--text text--darken-2"
                >Descrição</v-card-title>
                <v-card-text v-text="automacao.descricao" class="font-weight-light"></v-card-text>
              </v-card>
            </v-menu>
            <v-divider :key="`divider-${automacao.id}`" v-if="index < automacoes.length - 1"></v-divider>
          </template>
          <v-list-tile v-if="!loading && !automacoes.length">
            <v-list-tile-content>
              <v-list-tile-title
                class="text-xs-center title font-weight-light"
              >Sem automações cadastradas no momento</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog width="450" lazy v-model="dialogApagarAutomacao">
      <v-card>
        <v-card-text
          class="text-xs-center headline red--text text--darken-2"
        >Deseja apagar a automacao {{automacaoSelecionada.nome}}?</v-card-text>
        <v-card-text
          class="subheading grey--text text-xs-center text--darken-2"
        >Essa operação não poderá ser desfeita</v-card-text>
        <v-card-actions>
          <v-btn
            block
            flat
            class="title font-weight-regular"
            color="green darken-1"
            @click="dialogApagarAutomacao = false"
          >CANCELAR</v-btn>
          <v-btn
            block
            flat
            class="title font-weight-regular"
            color="grey lighten-1"
            @click="apagarAutomacao()"
          >CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CadAutomacao from '@/components/cadastros/CadAutomacao'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: { CadAutomacao, SmartLockMessage },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      automacaoSelecionada: {},
      dialogCadAutomacao: false,
      dialogApagarAutomacao: false
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    tiposVeiculo () {
      return this.$store.getters.tiposVeiculo
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    automacoes () {
      return this.$store.getters.automacoes
    }
  },
  watch: {
    headers (val) {
      if (val) {
        this.$store.dispatch('carregarAutomacoes')
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('carregarAutomacoes')
    }
  },
  methods: {
    apagarAutomacao () {
      this.$store.dispatch('apagarAutomacao', this.automacaoSelecionada.id).then(() => {
        this.dialogApagarAutomacao = false
        this.showInfo('Automação apagada com sucesso')
      }).catch(error => {
        this.dialogApagarAutomacao = false
        this.showError(error)
      })
    },
    selecionarAutomacao (automacao) {
      this.automacaoSelecionada = automacao
      this.dialogApagarAutomacao = true
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
      this.$store.dispatch('carregarAutomacoes')
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
